export default "__VITE_ASSET__BeinBIEq__"